module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMSAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC42MTIzNzIiIHk9IjMuNDA5NzEiIHdpZHRoPSI1LjMyNTAyIiBoZWlnaHQ9IjcuNTI1MDIiIHJ4PSIxLjUiIHRyYW5zZm9ybT0icm90YXRlKC0xNSAwLjYxMjM3MiAzLjQwOTcxKSIgZmlsbD0iI0Q5RDlEOSIgZmlsbC1vcGFjaXR5PSIwLjEiIHN0cm9rZT0iIzEyMTIxMiIvPgo8cmVjdCB4PSI0LjUiIHk9IjEuMjA4OTgiIHdpZHRoPSI2IiBoZWlnaHQ9IjkiIHJ4PSIxLjUiIGZpbGw9IiNFMEM0N0QiIHN0cm9rZT0iIzEyMTIxMiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tip-bg.svg
// module id = mjZw
// module chunks = 2